export default __webpack_public_path__ + "static/media/medical_history_pg2.ea9cdc2e.pdf";